















































import Vue from 'vue'
import InformationBox from './InformationBox.vue'
import LunchImageCarousel from './LunchImageCarousel.vue'


export default Vue.extend({
  components: {
    InformationBox,
    LunchImageCarousel
  },
  methods: {
    postDisplay(placelunchpost: any) {
      if (placelunchpost.iframe_url) {
        return 'iframe'
      }
      return 'description'
    },
    originalPostUrl(placelunchpost: any) {
      return (placelunchpost && (placelunchpost.link || placelunchpost.facebook_permalink_url)) || ''
    },
    postImages (placelunchpost: any) {
      const images = placelunchpost && placelunchpost.placelunchpostimage_set
      return Array.isArray(images) ? images : []
    },
    formatDate(date: any) {
      const locale = this.$store.state.currentLanguage == 'pol' ? 'pl' : 'en-US';
      return date.toLocaleDateString(locale, {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    },
    openImage(url: string) {
      if (url) {
        window.open(url, '_blank', 'noopener');
      }
    },
  },
})
